import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useContext, useMemo, useState } from "react";
import LoadingComponent from "../../components/LoadingComponent/LoadingComponent.tsx";
import { ColunasInicial, useProfile } from "../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../contexts/RequestController";
import { Coluna } from "../../models/ColunaModel.ts";
import { editaUsuarioTabelaPorId } from "../../services/ModuloGerenciador/UsuarioTabela";
import CustomButton from "../CustomButton/CustomButton";
import CustomButtonV2 from "../CustomButtonV2/CustomButtonV2.js";
import "../ModalConfigTabela/ModalConfigTabela.css";

export interface SimpleDialogProps {
	titulo: string;
	tituloBotao?: string;
	tituloConfirmar: string;
	texto?: string;
	checks: Coluna[];
	dataAlteracao?: string;
	open: boolean;
	nome: string;
	onClose: () => void;
	onClick?: () => void;
}

function ModalConfigTabela(props: SimpleDialogProps) {
	const {
		coresEmpresa,
		tabelaEmpresa,
		tabelaUsuario,
		setTabelaUsuario,
		profile,
	} = useProfile();
	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { onClose, open } = props;

	const handleClose = () => {
		onClose();
	};

	const [loading, setLoading] = useState(false);

	const unidEmbarqueValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[1],
		[tabelaEmpresa]
	);

	const empresaValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[2],
		[tabelaEmpresa]
	);

	const filialValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[3],
		[tabelaEmpresa]
	);

	const rotaEmbarqueValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[4],
		[tabelaEmpresa]
	);

	const pedidoValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[5],
		[tabelaEmpresa]
	);

	const cteValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[6],
		[tabelaEmpresa]
	);

	const previsaoEmbarqueValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[7],
		[tabelaEmpresa]
	);

	const previsaoEntregaValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[8],
		[tabelaEmpresa]
	);

	const dataHoraChegadaEmbarqueValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[9],
		[tabelaEmpresa]
	);

	const dataHoraEmbarcadoValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[10],
		[tabelaEmpresa]
	);

	const dataHoraChegadaEntregaValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[11],
		[tabelaEmpresa]
	);

	const dataHoraEntregueValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[12],
		[tabelaEmpresa]
	);

	const aceiteValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[13],
		[tabelaEmpresa]
	);

	const statusValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[14],
		[tabelaEmpresa]
	);

	const placaCavaloValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[15],
		[tabelaEmpresa]
	);

	const placaCarretaValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[16],
		[tabelaEmpresa]
	);

	const placaCarreta2Value = useMemo(
		() => tabelaEmpresa?.Embarque?.[17],
		[tabelaEmpresa]
	);

	const proprietarioValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[18],
		[tabelaEmpresa]
	);

	const motoristaValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[19],
		[tabelaEmpresa]
	);

	const freteFiscalValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[20],
		[tabelaEmpresa]
	);

	const icmsValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[21],
		[tabelaEmpresa]
	);

	const freteMotoristaValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[22],
		[tabelaEmpresa]
	);

	const adicionalEmpresa = useMemo(
		() => tabelaEmpresa?.Embarque?.[23],
		[tabelaEmpresa]
	);

	const adicionalMotoristaValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[24],
		[tabelaEmpresa]
	);

	const numeroEixosEmbarqueValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[25],
		[tabelaEmpresa]
	);

	const pedagioValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[26],
		[tabelaEmpresa]
	);

	const classificacaoValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[27],
		[tabelaEmpresa]
	);

	const margemValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[28],
		[tabelaEmpresa]
	);

	const adiantamentoValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[29],
		[tabelaEmpresa]
	);

	const saldoValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[30],
		[tabelaEmpresa]
	);

	const meioPagamentoValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[31],
		[tabelaEmpresa]
	);

	const meioPagamento2Value = useMemo(
		() => tabelaEmpresa?.Embarque?.[32],
		[tabelaEmpresa]
	);

	const kmValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[33],
		[tabelaEmpresa]
	);

	const clienteValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[34],
		[tabelaEmpresa]
	);

	const embarcadorEmbValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[35],
		[tabelaEmpresa]
	);

	const destinatarioEmbValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[36],
		[tabelaEmpresa]
	);

	const loadValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[37],
		[tabelaEmpresa]
	);

	const mercadoriaValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[38],
		[tabelaEmpresa]
	);

	const pesoValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[39],
		[tabelaEmpresa]
	);

	const embalagemEmbValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[40],
		[tabelaEmpresa]
	);

	const observacaoValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[41],
		[tabelaEmpresa]
	);

	const frotaValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[42],
		[tabelaEmpresa]
	);

	const canceladoValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[43],
		[tabelaEmpresa]
	);

	const motivoEmbarqueValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[44],
		[tabelaEmpresa]
	);

	const usuarioResponsavelValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[45],
		[tabelaEmpresa]
	);

	const nEntregasValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[46],
		[tabelaEmpresa]
	);

	const comprovanteValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[47],
		[tabelaEmpresa]
	);

	const checkinValue = useMemo(
		() => tabelaEmpresa?.Embarque?.[48],
		[tabelaEmpresa]
	);

	const quebraTabelaEmbarque = useMemo(
		() => tabelaEmpresa?.Embarque?.[49],
		[tabelaEmpresa]
	);

	const configDataHora = useMemo(
		() => tabelaEmpresa?.Embarque?.[50],
		[tabelaEmpresa]
	);

	const configEntrega = useMemo(
		() => tabelaEmpresa?.Embarque?.[51],
		[tabelaEmpresa]
	);	

	const pedidoPValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[0],
		[tabelaEmpresa]
	);

	const tipoRotaValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[1],
		[tabelaEmpresa]
	);

	const freteFiscalPValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[2],
		[tabelaEmpresa]
	);

	const icmsPValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[3],
		[tabelaEmpresa]
	);

	const pedagioPValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[4],
		[tabelaEmpresa]
	);

	const classificacaoPValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[5],
		[tabelaEmpresa]
	);

	const kmPValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[6],
		[tabelaEmpresa]
	);

	const clientePValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[7],
		[tabelaEmpresa]
	);

	const embarcadorPValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[8],
		[tabelaEmpresa]
	);

	const destinatarioPValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[9],
		[tabelaEmpresa]
	);

	const freteMotoristaPValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[10],
		[tabelaEmpresa]
	);

	const observacaoPValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[11],
		[tabelaEmpresa]
	);

	const permiteAlterarFreteFiscalValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[12],
		[tabelaEmpresa]
	);

	const valorEmbarquePedidoValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[13],
		[tabelaEmpresa]
	);

	const icmsEmbutidoValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[14],
		[tabelaEmpresa]
	);

	const icmsEmbarcadorValue = useMemo(
		() => tabelaEmpresa?.Pedido?.[15],
		[tabelaEmpresa]
	);

	const freteNormalvalue = useMemo(
		() => tabelaEmpresa?.Pedido?.[16],
		[tabelaEmpresa]
	);

	const quebraTabelaPedido = useMemo(
		() => tabelaEmpresa?.Pedido?.[17],
		[tabelaEmpresa]
	);


	const [pedidoPVisivel, setPedidoPVisivel] = useState(
		tabelaUsuario?.Pedido?.[0] ?? {}
	);

	const handleOnChangePedidoPVisivel = () => {
		setPedidoPVisivel({
			nomeColuna: "N Pedido",
			field: "pedido",
			visivel: pedidoPVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [tipoRotaVisivel, setTipoRotaVisivel] = useState(
		tabelaUsuario?.Pedido?.[1] ?? {}
	);

	const handleOnChangeTipoRotaVisivel = () => {
		setTipoRotaVisivel({
			nomeColuna: "Rota",
			field: "tipoRota",
			visivel: tipoRotaVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [freteFiscalPVisivel, setFreteFiscalPVisivel] = useState(
		tabelaUsuario?.Pedido?.[2] ?? {}
	);

	const handleOnChangeFreteFiscalPVisivel = () => {
		setFreteFiscalPVisivel({
			nomeColuna: "Frete Fiscal",
			field: "freteFiscal",
			visivel: freteFiscalPVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [icmsPVisivel, setIcmsPVisivel] = useState(
		tabelaUsuario?.Pedido?.[3] ?? {}
	);

	const handleOnChangeIcmsPVisivel = () => {
		setIcmsPVisivel({
			nomeColuna: "ICMS",
			field: "icms",
			visivel: icmsPVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [pedagioPVisivel, setPedagioPVisivel] = useState(
		tabelaUsuario?.Pedido?.[4] ?? {}
	);

	const handleOnChangePedagioPVisivel = () => {
		setPedagioPVisivel({
			nomeColuna: "Pedagio",
			field: "pedagio",
			visivel: pedagioPVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [classificacaoPVisivel, setClassificacaoPVisivel] = useState(
		tabelaUsuario?.Pedido?.[5] ?? {}
	);

	const handleOnChangeClassificacaoPVisivel = () => {
		setClassificacaoPVisivel({
			nomeColuna: "Classificação",
			field: "classificacao",
			visivel: classificacaoPVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [kmPVisivel, setKmPVisivel] = useState(
		tabelaUsuario?.Pedido?.[6] ?? {}
	);

	const handleOnChangeKmPVisivel = () => {
		setKmPVisivel({
			nomeColuna: "Km",
			field: "km",
			visivel: kmPVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [clientePVisivel, setClientePVisivel] = useState(
		tabelaUsuario?.Pedido?.[7] ?? {}
	);

	const handleOnChangeClientePVisivel = () => {
		setClientePVisivel({
			nomeColuna: "Cliente",
			field: "cliente",
			visivel: clientePVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [embarcadorPVisivel, setEmbarcadorPVisivel] = useState(
		tabelaUsuario?.Pedido?.[8] ?? {}
	);

	const handleOnChangeEmbarcadorPVisivel = () => {
		setEmbarcadorPVisivel({
			nomeColuna: "Embarcador",
			field: "embarcador",
			visivel: embarcadorPVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [destinatarioPVisivel, setDestinatarioPVisivel] = useState(
		tabelaUsuario?.Pedido?.[10] ?? {}
	);

	const handleOnChangeDestinatarioPVisivel = () => {
		setDestinatarioPVisivel({
			nomeColuna: "Destinatario",
			field: "destinatario",
			visivel: destinatarioPVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [freteMotoristaPVisivel, setFreteMotoristaPVisivel] = useState(
		tabelaUsuario?.Pedido?.[11] ?? {}
	);

	const handleOnChangeFreteMotoristaPVisivel = () => {
		setFreteMotoristaPVisivel({
			nomeColuna: "Frete Motorista",
			field: "freteMotorista",
			visivel: freteMotoristaPVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [observacaoPVisivel, setObservacaoPVisivel] = useState(
		tabelaUsuario?.Pedido?.[12] ?? {}
	);

	const handleOnChangeObservacaoPVisivel = () => {
		setObservacaoPVisivel({
			nomeColuna: "Observação",
			field: "observacao",
			visivel: observacaoPVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [
		permiteAlterarFreteFiscalVisivel,
		setPermiteAlterarFreteFiscalVisivel,
	] = useState(tabelaUsuario?.Pedido?.[13] ?? {});

	const handleOnChangePermiteAlterarFreteFiscalVisivel = () => {
		setPermiteAlterarFreteFiscalVisivel({
			nomeColuna: "Permite Alterar Frete Fiscal",
			field: "permiteAlterarFreteFiscal",
			visivel:
				permiteAlterarFreteFiscalVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [valorEmbarquePedidoVisivel, setValorEmbarquePedidoVisivel] = useState(
		tabelaUsuario?.Pedido?.[14] ?? {}
	);

	const handleOnChangeValorEmbarquePedidoVisivel = () => {
		setValorEmbarquePedidoVisivel({
			nomeColuna: "Valor Embarque Pedido",
			field: "valorEmbarque",
			visivel:
				valorEmbarquePedidoVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [icmsEmbutidoVisivel, setIcmsEmbutidoVisivel] = useState(
		tabelaUsuario?.Pedido?.[14] ?? {}
	);

	const handleOnChangeIcmsEmbutidoVisivel = () => {
		setIcmsEmbutidoVisivel({
			nomeColuna: "ICMS Embutido",
			field: "icmsEmbutido",
			visivel: icmsEmbutidoVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [icmsEmbarcadorVisivel, setIcmsEmbarcadorVisivel] = useState(
		tabelaUsuario?.Pedido?.[15] ?? {}
	);

	const handleOnChangeIcmsEmbarcadorVisivel = () => {
		setIcmsEmbarcadorVisivel({
			nomeColuna: "ICMS Embarcador",
			field: "icmsEmbarcador",
			visivel: icmsEmbarcadorVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [freteNormalVisivel, setFreteNormalVisivel] = useState(
		tabelaUsuario?.Pedido?.[14] ?? {}
	);

	const handleOnChangeFreteNormalVisivel = () => {
		setFreteNormalVisivel({
			nomeColuna: "Frete Normal",
			field: "freteNormal",
			visivel: freteNormalVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [unidEmbarqueVisivel, setUnidEmbarqueVisivel] = useState(
		tabelaUsuario.Embarque[1]
	);

	const handleOnChangeUnidEmbarqueVisivel = () => {
		setUnidEmbarqueVisivel({
			nomeColuna: "Unidade de Embarque",
			field: "unidEmbarque",
			visivel: unidEmbarqueVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [empresaVisivel, setEmpresaVisivel] = useState(
		tabelaUsuario.Embarque[2]
	);

	const handleOnChangeEmpresaVisivel = () => {
		setEmpresaVisivel({
			nomeColuna: "Empresa",
			field: "empresa",
			visivel: empresaVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [filialVisivel, setFilialVisivel] = useState(tabelaUsuario.Embarque[3]);

	const handleOnChangeFilialVisivel = () => {
		setFilialVisivel({
			nomeColuna: "Filial",
			field: "filial",
			visivel: filialVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [rotaEmbarqueVisivel, setRotaEmbarqueVisivel] = useState(
		tabelaUsuario.Embarque[4]
	);

	const handleOnChangeRotaEmbarqueVisivel = () => {
		setRotaEmbarqueVisivel({
			nomeColuna: "RotaEmbarque",
			field: "rota",
			visivel: rotaEmbarqueVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [pedidoVisivel, setPedidoVisivel] = useState(tabelaUsuario.Embarque[5]);

	const handleOnChangePedidoVisivel = () => {
		setPedidoVisivel({
			nomeColuna: "Pedido",
			field: "pedido",
			visivel: pedidoVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [cteVisivel, setCteVisivel] = useState(tabelaUsuario.Embarque[6]);

	const handleOnChangeCteVisivel = () => {
		setCteVisivel({
			nomeColuna: "Cte",
			field: "cte",
			visivel: cteVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [previsaoEmbarqueVisivel, setPrevisaoEmbarqueVisivel] = useState(
		tabelaUsuario.Embarque[7]
	);

	const handleOnChangePrevisaoEmbarqueVisivel = () => {
		setPrevisaoEmbarqueVisivel({
			nomeColuna: "Previsão Embarque",
			field: "previsaoEmbarque",
			visivel: previsaoEmbarqueVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [previsaoEntregaVisivel, setPrevisaoEntregaVisivel] = useState(
		tabelaUsuario.Embarque[8]
	);

	const handleOnChangePrevisaoEntregaVisivel = () => {
		setPrevisaoEntregaVisivel({
			nomeColuna: "Previsão Entrega",
			field: "previsaoEntrega",
			visivel: previsaoEntregaVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [dataHoraChegadaEmbarqueVisivel, setDataHoraChegadaEmbarqueVisivel] =
		useState(tabelaUsuario.Embarque[9]);

	const handleOnChangeDataHoraChegadaEmbarqueVisivel = () => {
		setDataHoraChegadaEmbarqueVisivel({
			nomeColuna: "Data Hora Chegada Embarque",
			field: "dataHoraChegadaEmbarque",
			visivel:
				dataHoraChegadaEmbarqueVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [dataHoraEmbarcadoVisivel, setDataHoraEmbarcadoVisivel] = useState(
		tabelaUsuario.Embarque[10]
	);

	const handleOnChangeDataHoraEmbarcadoVisivel = () => {
		setDataHoraEmbarcadoVisivel({
			nomeColuna: "Data Hora Embarcado",
			field: "dataHoraEmbarcado",
			visivel: dataHoraEmbarcadoVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [dataHoraChegadaEntregaVisivel, setDataHoraChegadaEntregaVisivel] =
		useState(tabelaUsuario.Embarque[11]);

	const handleOnChangeDataHoraChegadaEntregaVisivel = () => {
		setDataHoraChegadaEntregaVisivel({
			nomeColuna: "Data Hora Chegada Entrega",
			field: "dataHoraChegadaEntrega",
			visivel:
				dataHoraChegadaEntregaVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [dataHoraEntregueVisivel, setDataHoraEntregueVisivel] = useState(
		tabelaUsuario.Embarque[12]
	);

	const handleOnChangeDataHoraEntregueVisivel = () => {
		setDataHoraEntregueVisivel({
			nomeColuna: "Data Hora Entregue",
			field: "dataHoraEntregue",
			visivel: dataHoraEntregueVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [aceiteVisivel, setAceiteVisivel] = useState(
		tabelaUsuario.Embarque[13]
	);

	const handleOnChangeAceiteVisivel = () => {
		setAceiteVisivel({
			nomeColuna: "Aceite",
			field: "aceite",
			visivel: aceiteVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [statusVisivel, setStatusVisivel] = useState(
		tabelaUsuario.Embarque[14]
	);

	const handleOnChangeStatusVisivel = () => {
		setStatusVisivel({
			nomeColuna: "Status",
			field: "status",
			visivel: statusVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [placaCavaloVisivel, setPlacaCavaloVisivel] = useState(
		tabelaUsuario.Embarque[15]
	);

	const handleOnChangePlacaCavaloVisivel = () => {
		setPlacaCavaloVisivel({
			nomeColuna: "Placa Cavalo",
			field: "placaCavalo",
			visivel: placaCavaloVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [placaCarretaVisivel, setPlacaCarretaVisivel] = useState(
		tabelaUsuario.Embarque[16]
	);

	const handleOnChangePlacaCarretaVisivel = () => {
		setPlacaCarretaVisivel({
			nomeColuna: "Placa Carreta",
			field: "placaCarreta",
			visivel: placaCarretaVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [placaCarreta2Visivel, setPlacaCarreta2Visivel] = useState(
		tabelaUsuario.Embarque[17]
	);

	const handleOnChangePlacaCarreta2Visivel = () => {
		setPlacaCarreta2Visivel({
			nomeColuna: "Placa Segunda Carreta",
			field: "placaCarreta2",
			visivel: placaCarreta2Visivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [proprietarioVisivel, setProprietarioVisivel] = useState(
		tabelaUsuario.Embarque[18]
	);

	const handleOnChangeProprietarioVisivel = () => {
		setProprietarioVisivel({
			nomeColuna: "Proprietario",
			field: "proprietario",
			visivel: proprietarioVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [motoristaVisivel, setMotoristaVisivel] = useState(
		tabelaUsuario.Embarque[19]
	);

	const handleOnChangeMotoristaVisivel = () => {
		setMotoristaVisivel({
			nomeColuna: "Motorista",
			field: "motorista",
			visivel: motoristaVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [freteFiscalVisivel, setFreteFiscalVisivel] = useState(
		tabelaUsuario.Embarque[20]
	);

	const handleOnChangeFreteFiscalVisivel = () => {
		setFreteFiscalVisivel({
			nomeColuna: "Frete Fiscal",
			field: "freteFiscal",
			visivel: freteFiscalVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [icmsVisivel, setIcmsVisivel] = useState(tabelaUsuario.Embarque[21]);

	const handleOnChangeIcmsVisivel = () => {
		setIcmsVisivel({
			nomeColuna: "ICMS",
			field: "icms",
			visivel: icmsVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [freteMotoristaVisivel, setFreteMotoristaVisivel] = useState(
		tabelaUsuario.Embarque[22]
	);

	const handleOnChangeFreteMotoristaVisivel = () => {
		setFreteMotoristaVisivel({
			nomeColuna: "Frete Motorista",
			field: "freteMotorista",
			visivel: freteMotoristaVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [adicionalEmpresaVisivel, setAdicionalEmpresaVisivel] = useState(
		tabelaUsuario.Embarque[23]
	);

	const handleOnChangeAdicionalEmpresaVisivel = () => {
		setAdicionalEmpresaVisivel({
			nomeColuna: "Adicional Empresa",
			field: "adicionalEmpresa",
			visivel: adicionalEmpresaVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [adicionalMotoristaVisivel, setAdicionalMotoristaVisivel] = useState(
		tabelaUsuario.Embarque[24]
	);

	const handleOnChangeAdicionalMotoristaVisivel = () => {
		setAdicionalMotoristaVisivel({
			nomeColuna: "Adicional Motorista",
			field: "adicionalMotorista",
			visivel: adicionalMotoristaVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [numeroEixosEmbarqueVisivel, setNumeroEixosEmbarqueVisivel] = useState(
		tabelaUsuario.Embarque[25]
	);

	const handleOnChangeNumeroEixosEmbarqueVisivel = () => {
		setNumeroEixosEmbarqueVisivel({
			nomeColuna: "Eixos",
			field: "numeroEixos",
			visivel:
				numeroEixosEmbarqueVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [pedagioVisivel, setPedagioVisivel] = useState(
		tabelaUsuario.Embarque[26]
	);

	const handleOnChangePedagioVisivel = () => {
		setPedagioVisivel({
			nomeColuna: "Pedagio",
			field: "pedagio",
			visivel: pedagioVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [classificacaoVisivel, setClassificacaoVisivel] = useState(
		tabelaUsuario.Embarque[27]
	);

	const handleOnChangeClassificacaoVisivel = () => {
		setClassificacaoVisivel({
			nomeColuna: "Classificação",
			field: "classificacao",
			visivel: classificacaoVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [margemVisivel, setMargemVisivel] = useState(
		tabelaUsuario.Embarque[28]
	);

	const handleOnChangeMargemVisivel = () => {
		setMargemVisivel({
			nomeColuna: "Margem",
			field: "margem",
			visivel: margemVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [adiantamentoVisivel, setAdiamentoVisivel] = useState(
		tabelaUsuario.Embarque[29]
	);

	const handleOnChangeAdiamentoVisivel = () => {
		setAdiamentoVisivel({
			nomeColuna: "Adiamento",
			field: "adiantamento",
			visivel: adiantamentoVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [saldoVisivel, setSaldoVisivel] = useState(tabelaUsuario.Embarque[30]);

	const handleOnChangeSaldoVisivel = () => {
		setSaldoVisivel({
			nomeColuna: "Saldo",
			field: "saldo",
			visivel: saldoVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [meioPagamentoVisivel, setMeioPagamentoVisivel] = useState(
		tabelaUsuario.Embarque[31]
	);

	const handleOnChangeMeioPagamentoVisivel = () => {
		setMeioPagamentoVisivel({
			nomeColuna: "Meio Pagamento",
			field: "meioPagamento",
			visivel: meioPagamentoVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [meioPagamento2Visivel, setMeioPagamento2Visivel] = useState(
		tabelaUsuario.Embarque[32]
	);

	const handleOnChangeMeioPagamento2Visivel = () => {
		setMeioPagamento2Visivel({
			nomeColuna: "Meio Pagamento Dois",
			field: "meioPagamento2",
			visivel: meioPagamento2Visivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [kmVisivel, setKmVisivel] = useState(tabelaUsuario.Embarque[33]);

	const handleOnChangeKmVisivel = () => {
		setKmVisivel({
			nomeColuna: "Km",
			field: "km",
			visivel: kmVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [clienteVisivel, setClienteVisivel] = useState(
		tabelaUsuario.Embarque[34]
	);

	const handleOnChangeClienteVisivel = () => {
		setClienteVisivel({
			nomeColuna: "Cliente",
			field: "cliente",
			visivel: clienteVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [embarcadorEmbVisivel, setEmbarcadorEmbVisivel] = useState(
		tabelaUsuario.Embarque[35]
	);

	const handleOnChangeEmbarcadorEmbVisivel = () => {
		setEmbarcadorEmbVisivel({
			nomeColuna: "Embarcador",
			field: "embarcador",
			visivel: embarcadorEmbVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [destinatarioEmbVisivel, setDestinatarioEmbVisivel] = useState(
		tabelaUsuario.Embarque[36]
	);

	const handleOnChangeDestinatarioEmbVisivel = () => {
		setDestinatarioEmbVisivel({
			nomeColuna: "Destinatario",
			field: "destinatario",
			visivel: destinatarioEmbVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [loadVisivel, setLoadVisivel] = useState(tabelaUsuario.Embarque[37]);

	const handleOnChangeLoadVisivel = () => {
		setLoadVisivel({
			nomeColuna: "Load",
			field: "load",
			visivel: loadVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [mercadoriaVisivel, setMercadoriaVisivel] = useState(
		tabelaUsuario.Embarque[38]
	);

	const handleOnChangeMercadoriaVisivel = () => {
		setMercadoriaVisivel({
			nomeColuna: "Mercadoria",
			field: "mercadoria",
			visivel: mercadoriaVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [pesoVisivel, setPesoVisivel] = useState(tabelaUsuario.Embarque[39]);

	const handleOnChangePesoVisivel = () => {
		setPesoVisivel({
			nomeColuna: "Peso",
			field: "peso",
			visivel: pesoVisivel?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [embalagemEmbVisivel, setEmbalagemEmbVisivel] = useState(
		tabelaUsuario.Embarque[40]
	);

	const handleOnChangeEmbalagemEmbVisivel = () => {
		setEmbalagemEmbVisivel({
			nomeColuna: "Embalagem",
			field: "embalagem",
			visivel: embalagemEmbVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [observacaoVisivel, setObservacaoVisivel] = useState(
		tabelaUsuario.Embarque[41]
	);

	const handleOnChangeObservacaoVisivel = () => {
		setObservacaoVisivel({
			nomeColuna: "Observação",
			field: "observacao",
			visivel: observacaoVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [frotaVisivel, setFrotaVisivel] = useState(tabelaUsuario.Embarque[42]);

	const handleOnChangeFrotaVisivel = () => {
		setFrotaVisivel({
			nomeColuna: "Frota",
			field: "frota",
			visivel: frotaVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [canceladoVisivel, setCanceladoVisivel] = useState(
		tabelaUsuario.Embarque[43]
	);

	const handleOnChangeCanceladoVisivel = () => {
		setCanceladoVisivel({
			nomeColuna: "Cancelado",
			field: "cancelado",
			visivel: canceladoVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [motivoVisivel, setMotivoVisivel] = useState(
		tabelaUsuario.Embarque[44]
	);

	const handleOnChangeMotivoVisivel = () => {
		setMotivoVisivel({
			nomeColuna: "Motivo",
			field: "motivo",
			visivel: motivoVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [usuarioResponsavelVisivel, setUsuarioResponsavelVisivel] = useState(
		tabelaUsuario.Embarque[45]
	);

	const handleOnChangeUsuarioResponsavelVisivel = () => {
		setUsuarioResponsavelVisivel({
			nomeColuna: "Usuário Responsável",
			field: "usuarioResponsavel",
			visivel: usuarioResponsavelVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [nEntregasVisivel, setNEntregasVisivel] = useState(
		tabelaUsuario.Embarque[46]
	);

	const handleOnChangeNEntregasVisivel = () => {
		setNEntregasVisivel({
			nomeColuna: "Entregas",
			field: "nEtregas",
			visivel: nEntregasVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [comprovanteVisivel, setComprovanteVisivel] = useState(
		tabelaUsuario.Embarque[47]
	);

	const handleOnChangeComprovanteVisivel = () => {
		setComprovanteVisivel({
			nomeColuna: "Comprovante",
			field: "comprovante",
			visivel: comprovanteVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [checkinVisivel, setCheckinVisivel] = useState(
		tabelaUsuario.Embarque[48]
	);

	const handleOnChangeCheckinVisivel = () => {
		setCheckinVisivel({
			nomeColuna: "Check-in",
			field: "checkInFeito",
			visivel: checkinVisivel?.visivel === "true" ? "false" : "true",
		});
	};

	const [configDataHoraVisivel, setConfigDataHoraVisivel] = useState(
		tabelaUsuario.Embarque?.[50]
	);

	const handleOnChangeConfigDataHoraVisivel = () => {
		setConfigDataHoraVisivel({
			configDataHora: configDataHoraVisivel?.configDataHora ? false : true,
		});
	};

	const [configEntregaVisivel, setConfigEntregaVisivel] = useState(
		tabelaUsuario.Embarque?.[51]
	);

	const handleOnChangeConfigEntregaVisivel = () => {
		setConfigEntregaVisivel({
			configEntrega: configEntregaVisivel?.configEntrega ? false : true,
		});
	};

	const [unidEmbarqueVisivelModelo, setUnidEmbarqueVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[1]
	);

	const handleOnChangeUnidEmbarqueVisivelModelo = () => {
		setUnidEmbarqueVisivelModelo({
			nomeColuna: "Unidade de Embarque",
			field: "unidEmbarque",
			visivel: unidEmbarqueVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [empresaVisivelModelo, setEmpresaVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[2]
	);

	const handleOnChangeEmpresaVisivelModelo = () => {
		setEmpresaVisivelModelo({
			nomeColuna: "Empresa",
			field: "empresa",
			visivel: empresaVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [filialVisivelModelo, setFilialVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[3]
	);

	const handleOnChangeFilialVisivelModelo = () => {
		setFilialVisivelModelo({
			nomeColuna: "Filial",
			field: "filial",
			visivel: filialVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [rotaEmbarqueVisivelModelo, setRotaEmbarqueVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[4]
	);

	const handleOnChangeRotaEmbarqueVisivelModelo = () => {
		setRotaEmbarqueVisivelModelo({
			nomeColuna: "RotaEmbarque",
			field: "rota",
			visivel: rotaEmbarqueVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [pedidoVisivelModelo, setPedidoVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[5]
	);

	const handleOnChangePedidoVisivelModelo = () => {
		setPedidoVisivelModelo({
			nomeColuna: "Pedido",
			field: "pedido",
			visivel: pedidoVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [cteVisivelModelo, setCteVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[6]
	);

	const handleOnChangeCteVisivelModelo = () => {
		setCteVisivelModelo({
			nomeColuna: "Cte",
			field: "cte",
			visivel: cteVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [previsaoEmbarqueVisivelModelo, setPrevisaoEmbarqueVisivelModelo] =
		useState(tabelaUsuario.ModeloEmbarque?.[7]);

	const handleOnChangePrevisaoEmbarqueVisivelModelo = () => {
		setPrevisaoEmbarqueVisivelModelo({
			nomeColuna: "Previsão Embarque",
			field: "previsaoEmbarque",
			visivel:
				previsaoEmbarqueVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [previsaoEntregaVisivelModelo, setPrevisaoEntregaVisivelModelo] =
		useState(tabelaUsuario.ModeloEmbarque?.[8]);

	const handleOnChangePrevisaoEntregaVisivelModelo = () => {
		setPrevisaoEntregaVisivelModelo({
			nomeColuna: "Previsão Entrega",
			field: "previsaoEntrega",
			visivel:
				previsaoEntregaVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [
		dataHoraChegadaEmbarqueVisivelModelo,
		setDataHoraChegadaEmbarqueVisivelModelo,
	] = useState(tabelaUsuario.ModeloEmbarque?.[9]);

	const handleOnChangeDataHoraChegadaEmbarqueVisivelModelo = () => {
		setDataHoraChegadaEmbarqueVisivelModelo({
			nomeColuna: "Data Hora Chegada Embarque",
			field: "dataHoraChegadaEmbarque",
			visivel:
				dataHoraChegadaEmbarqueVisivelModelo?.visivel === "true"
					? "false"
					: "true",
		});
	};

	const [dataHoraEmbarcadoVisivelModelo, setDataHoraEmbarcadoVisivelModelo] =
		useState(tabelaUsuario.ModeloEmbarque?.[10]);

	const handleOnChangeDataHoraEmbarcadoVisivelModelo = () => {
		setDataHoraEmbarcadoVisivelModelo({
			nomeColuna: "Data Hora Embarcado",
			field: "dataHoraEmbarcado",
			visivel:
				dataHoraEmbarcadoVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [
		dataHoraChegadaEntregaVisivelModelo,
		setDataHoraChegadaEntregaVisivelModelo,
	] = useState(tabelaUsuario.ModeloEmbarque?.[11]);

	const handleOnChangeDataHoraChegadaEntregaVisivelModelo = () => {
		setDataHoraChegadaEntregaVisivelModelo({
			nomeColuna: "Data Hora Chegada Entrega",
			field: "dataHoraChegadaEntrega",
			visivel:
				dataHoraChegadaEntregaVisivelModelo?.visivel === "true"
					? "false"
					: "true",
		});
	};

	const [dataHoraEntregueVisivelModelo, setDataHoraEntregueVisivelModelo] =
		useState(tabelaUsuario.ModeloEmbarque?.[12]);

	const handleOnChangeDataHoraEntregueVisivelModelo = () => {
		setDataHoraEntregueVisivelModelo({
			nomeColuna: "Data Hora Entregue",
			field: "dataHoraEntregue",
			visivel:
				dataHoraEntregueVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [aceiteVisivelModelo, setAceiteVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[13]
	);

	const handleOnChangeAceiteVisivelModelo = () => {
		setAceiteVisivelModelo({
			nomeColuna: "Aceite",
			field: "aceite",
			visivel: aceiteVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [statusVisivelModelo, setStatusVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[14]
	);

	const handleOnChangeStatusVisivelModelo = () => {
		setStatusVisivelModelo({
			nomeColuna: "Status",
			field: "status",
			visivel: statusVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [placaCavaloVisivelModelo, setPlacaCavaloVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[15]
	);

	const handleOnChangePlacaCavaloVisivelModelo = () => {
		setPlacaCavaloVisivelModelo({
			nomeColuna: "Placa Cavalo",
			field: "placaCavalo",
			visivel: placaCavaloVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [placaCarretaVisivelModelo, setPlacaCarretaVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[16]
	);

	const handleOnChangePlacaCarretaVisivelModelo = () => {
		setPlacaCarretaVisivelModelo({
			nomeColuna: "Placa Carreta",
			field: "placaCarreta",
			visivel: placaCarretaVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [placaCarreta2VisivelModelo, setPlacaCarreta2VisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[17]
	);

	const handleOnChangePlacaCarreta2VisivelModelo = () => {
		setPlacaCarreta2VisivelModelo({
			nomeColuna: "Placa Segunda Carreta",
			field: "placaCarreta2",
			visivel:
				placaCarreta2VisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [proprietarioVisivelModelo, setProprietarioVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[18]
	);

	const handleOnChangeProprietarioVisivelModelo = () => {
		setProprietarioVisivelModelo({
			nomeColuna: "Proprietario",
			field: "proprietario",
			visivel: proprietarioVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [motoristaVisivelModelo, setMotoristaVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[19]
	);

	const handleOnChangeMotoristaVisivelModelo = () => {
		setMotoristaVisivelModelo({
			nomeColuna: "Motorista",
			field: "motorista",
			visivel: motoristaVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [freteFiscalVisivelModelo, setFreteFiscalVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[20]
	);

	const handleOnChangeFreteFiscalVisivelModelo = () => {
		setFreteFiscalVisivelModelo({
			nomeColuna: "Frete Fiscal",
			field: "freteFiscal",
			visivel: freteFiscalVisivelModelo?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [icmsVisivelModelo, setIcmsVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[21]
	);

	const handleOnChangeIcmsVisivelModelo = () => {
		setIcmsVisivelModelo({
			nomeColuna: "ICMS",
			field: "icms",
			visivel: icmsVisivelModelo?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [freteMotoristaVisivelModelo, setFreteMotoristaVisivelModelo] =
		useState(tabelaUsuario.ModeloEmbarque?.[22]);

	const handleOnChangeFreteMotoristaVisivelModelo = () => {
		setFreteMotoristaVisivelModelo({
			nomeColuna: "Frete Motorista",
			field: "freteMotorista",
			visivel:
				freteMotoristaVisivelModelo?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [adicionalEmpresaVisivelModelo, setAdicionalEmpresaVisivelModelo] =
		useState(tabelaUsuario.ModeloEmbarque?.[23]);

	const handleOnChangeAdicionalEmpresaVisivelModelo = () => {
		setAdicionalEmpresaVisivelModelo({
			nomeColuna: "Adicional Empresa",
			field: "adicionalEmpresa",
			visivel:
				adicionalEmpresaVisivelModelo?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [adicionalMotoristaVisivelModelo, setAdicionalMotoristaVisivelModelo] =
		useState(tabelaUsuario.ModeloEmbarque?.[24]);

	const handleOnChangeAdicionalMotoristaVisivelModelo = () => {
		setAdicionalMotoristaVisivelModelo({
			nomeColuna: "Adicional Motorista",
			field: "adicionalMotorista",
			visivel:
				adicionalMotoristaVisivelModelo?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [
		numeroEixosEmbarqueVisivelModelo,
		setNumeroEixosEmbarqueVisivelModelo,
	] = useState(tabelaUsuario.ModeloEmbarque?.[25]);

	const handleOnChangeNumeroEixosEmbarqueVisivelModelo = () => {
		setNumeroEixosEmbarqueVisivelModelo({
			nomeColuna: "Eixos",
			field: "numeroEixos",
			visivel:
				numeroEixosEmbarqueVisivelModelo?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [pedagioVisivelModelo, setPedagioVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[26]
	);

	const handleOnChangePedagioVisivelModelo = () => {
		setPedagioVisivelModelo({
			nomeColuna: "Pedagio",
			field: "pedagio",
			visivel: pedagioVisivelModelo?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [classificacaoVisivelModelo, setClassificacaoVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[27]
	);

	const handleOnChangeClassificacaoVisivelModelo = () => {
		setClassificacaoVisivelModelo({
			nomeColuna: "Classificação",
			field: "classificacao",
			visivel:
				classificacaoVisivelModelo?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [margemVisivelModelo, setMargemVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[28]
	);

	const handleOnChangeMargemVisivelModelo = () => {
		setMargemVisivelModelo({
			nomeColuna: "Margem",
			field: "margem",
			visivel: margemVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [adiantamentoVisivelModelo, setAdiamentoVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[29]
	);

	const handleOnChangeAdiamentoVisivelModelo = () => {
		setAdiamentoVisivelModelo({
			nomeColuna: "Adiamento",
			field: "adiantamento",
			visivel: adiantamentoVisivelModelo?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [saldoVisivelModelo, setSaldoVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[30]
	);

	const handleOnChangeSaldoVisivelModelo = () => {
		setSaldoVisivelModelo({
			nomeColuna: "Saldo",
			field: "saldo",
			visivel: saldoVisivelModelo?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [meioPagamentoVisivelModelo, setMeioPagamentoVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[31]
	);

	const handleOnChangeMeioPagamentoVisivelModelo = () => {
		setMeioPagamentoVisivelModelo({
			nomeColuna: "Meio Pagamento",
			field: "meioPagamento",
			visivel:
				meioPagamentoVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [meioPagamento2VisivelModelo, setMeioPagamento2VisivelModelo] =
		useState(tabelaUsuario.ModeloEmbarque?.[32]);

	const handleOnChangeMeioPagamento2VisivelModelo = () => {
		setMeioPagamento2VisivelModelo({
			nomeColuna: "Meio Pagamento Dois",
			field: "meioPagamento2",
			visivel:
				meioPagamento2VisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [kmVisivelModelo, setKmVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[33]
	);

	const handleOnChangeKmVisivelModelo = () => {
		setKmVisivelModelo({
			nomeColuna: "Km",
			field: "km",
			visivel: kmVisivelModelo?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [clienteVisivelModelo, setClienteVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[34]
	);

	const handleOnChangeClienteVisivelModelo = () => {
		setClienteVisivelModelo({
			nomeColuna: "Cliente",
			field: "cliente",
			visivel: clienteVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [embarcadorEmbVisivelModelo, setEmbarcadorEmbVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[35]
	);

	const handleOnChangeEmbarcadorEmbVisivelModelo = () => {
		setEmbarcadorEmbVisivelModelo({
			nomeColuna: "Embarcador",
			field: "embarcador",
			visivel:
				embarcadorEmbVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [destinatarioEmbVisivelModelo, setDestinatarioEmbVisivelModelo] =
		useState(tabelaUsuario.ModeloEmbarque?.[36]);

	const handleOnChangeDestinatarioEmbVisivelModelo = () => {
		setDestinatarioEmbVisivelModelo({
			nomeColuna: "Destinatario",
			field: "destinatario",
			visivel:
				destinatarioEmbVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [loadVisivelModelo, setLoadVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[37]
	);

	const handleOnChangeLoadVisivelModelo = () => {
		setLoadVisivelModelo({
			nomeColuna: "Load",
			field: "load",
			visivel: loadVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [mercadoriaVisivelModelo, setMercadoriaVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[38]
	);

	const handleOnChangeMercadoriaVisivelModelo = () => {
		setMercadoriaVisivelModelo({
			nomeColuna: "Mercadoria",
			field: "mercadoria",
			visivel: mercadoriaVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [pesoVisivelModelo, setPesoVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[39]
	);

	const handleOnChangePesoVisivelModelo = () => {
		setPesoVisivelModelo({
			nomeColuna: "Peso",
			field: "peso",
			visivel: pesoVisivelModelo?.visivel === "true" ? "false" : "true",
			tipo: "number",
		});
	};

	const [embalagemEmbVisivelModelo, setEmbalagemEmbVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[40]
	);

	const handleOnChangeEmbalagemEmbVisivelModelo = () => {
		setEmbalagemEmbVisivelModelo({
			nomeColuna: "Embalagem",
			field: "embalagem",
			visivel: embalagemEmbVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [observacaoVisivelModelo, setObservacaoVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[41]
	);

	const handleOnChangeObservacaoVisivelModelo = () => {
		setObservacaoVisivelModelo({
			nomeColuna: "Observação",
			field: "observacao",
			visivel: observacaoVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [frotaVisivelModelo, setFrotaVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[42]
	);

	const handleOnChangeFrotaVisivelModelo = () => {
		setFrotaVisivelModelo({
			nomeColuna: "Frota",
			field: "frota",
			visivel: frotaVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [canceladoVisivelModelo, setCanceladoVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[43]
	);

	const handleOnChangeCanceladoVisivelModelo = () => {
		setCanceladoVisivelModelo({
			nomeColuna: "Cancelado",
			field: "cancelado",
			visivel: canceladoVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [motivoVisivelModelo, setMotivoVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[44]
	);

	const handleOnChangeMotivoVisivelModelo = () => {
		setMotivoVisivelModelo({
			nomeColuna: "Motivo",
			field: "motivo",
			visivel: motivoVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [usuarioResponsavelVisivelModelo, setUsuarioResponsavelVisivelModelo] =
		useState(tabelaUsuario.ModeloEmbarque?.[45]);

	const handleOnChangeUsuarioResponsavelVisivelModelo = () => {
		setUsuarioResponsavelVisivelModelo({
			nomeColuna: "Usuário Responsável",
			field: "usuarioResponsavel",
			visivel:
				usuarioResponsavelVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [nEntregasVisivelModelo, setNEntregasVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[46]
	);

	const handleOnChangeNEntregasVisivelModelo = () => {
		setNEntregasVisivelModelo({
			nomeColuna: "Entregas",
			field: "nEtregas",
			visivel: nEntregasVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [comprovanteVisivelModelo, setComprovanteVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[47]
	);

	const handleOnChangeComprovanteVisivelModelo = () => {
		setComprovanteVisivelModelo({
			nomeColuna: "Comprovante",
			field: "comprovante",
			visivel: comprovanteVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [checkinVisivelModelo, setCheckinVisivelModelo] = useState(
		tabelaUsuario.ModeloEmbarque?.[48]
	);

	const handleOnChangeCheckinVisivelModelo = () => {
		setCheckinVisivelModelo({
			nomeColuna: "Check-in",
			field: "checkInFeito",
			visivel: checkinVisivelModelo?.visivel === "true" ? "false" : "true",
		});
	};

	const [configDataHoraVisivelModelo, setConfigDataHoraVisivelModelo] =
		useState(tabelaUsuario.ModeloModeloEmbarque?.[50]);

	const handleOnChangeConfigDataHoraVisivelModelo = () => {
		setConfigDataHoraVisivelModelo({
			configDataHora: configDataHoraVisivelModelo?.configDataHoraModelo
				? false
				: true,
		});
	};

	const valorInicial: ColunasInicial = {
		Embarque: [
			{
				nomeColuna: "Descrição",
				field: "descricao",
				visivel: "true",
			},
			{
				nomeColuna: unidEmbarqueValue?.nomeColuna,
				field: "unidEmbarque",
				visivel: unidEmbarqueVisivel?.visivel,
			},
			{
				nomeColuna: empresaValue?.nomeColuna,
				field: "empresa",
				visivel: empresaVisivel?.visivel,
			},
			{
				nomeColuna: filialValue?.nomeColuna,
				field: "filial",
				visivel: filialVisivel?.visivel,
			},
			{
				nomeColuna: rotaEmbarqueValue?.nomeColuna,
				field: "rota",
				visivel: rotaEmbarqueVisivel?.visivel,
			},
			{
				nomeColuna: pedidoValue?.nomeColuna,
				field: "pedido",
				visivel: pedidoVisivel?.visivel,
			},
			{
				nomeColuna: cteValue?.nomeColuna,
				field: "cte",
				visivel: cteVisivel?.visivel,
			},
			{
				nomeColuna: previsaoEmbarqueValue?.nomeColuna,
				field: "previsaoEmbarque",
				visivel: previsaoEmbarqueVisivel?.visivel,
			},
			{
				nomeColuna: previsaoEntregaValue?.nomeColuna,
				field: "previsaoEntrega",
				visivel: previsaoEntregaVisivel?.visivel,
			},
			{
				nomeColuna: dataHoraChegadaEmbarqueValue?.nomeColuna,
				field: "dataHoraChegadaEmbarque",
				visivel: dataHoraChegadaEmbarqueVisivel?.visivel,
			},
			{
				nomeColuna: dataHoraEmbarcadoValue?.nomeColuna,
				field: "dataHoraEmbarcado",
				visivel: dataHoraEmbarcadoVisivel?.visivel,
			},
			{
				nomeColuna: dataHoraChegadaEntregaValue?.nomeColuna,
				field: "dataHoraChegadaEntrega",
				visivel: dataHoraChegadaEntregaVisivel?.visivel,
			},
			{
				nomeColuna: dataHoraEntregueValue?.nomeColuna,
				field: "dataHoraEntregue",
				visivel: dataHoraEntregueVisivel?.visivel,
			},
			{
				nomeColuna: aceiteValue?.nomeColuna,
				field: "aceite",
				visivel: aceiteVisivel?.visivel,
			},
			{
				nomeColuna: statusValue?.nomeColuna,
				field: "status",
				visivel: statusVisivel?.visivel,
			},
			{
				nomeColuna: placaCavaloValue?.nomeColuna,
				field: "placaCavalo",
				visivel: placaCavaloVisivel?.visivel,
			},
			{
				nomeColuna: placaCarretaValue?.nomeColuna,
				field: "placaCarreta",
				visivel: placaCarretaVisivel?.visivel,
			},
			{
				nomeColuna: placaCarreta2Value?.nomeColuna,
				field: "placaCarreta2",
				visivel: placaCarreta2Visivel?.visivel,
			},
			{
				nomeColuna: proprietarioValue?.nomeColuna,
				field: "proprietario",
				visivel: proprietarioVisivel?.visivel,
			},
			{
				nomeColuna: motoristaValue?.nomeColuna,
				field: "veiculoMotorista",
				visivel: motoristaVisivel?.visivel,
			},
			{
				nomeColuna: freteFiscalValue?.nomeColuna,
				field: "freteFiscal",
				visivel: freteFiscalVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: icmsValue?.nomeColuna,
				field: "icms",
				visivel: icmsVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: freteMotoristaValue?.nomeColuna,
				field: "freteMotorista",
				visivel: freteMotoristaVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: adicionalEmpresa?.nomeColuna,
				field: "adicionalEmpresa",
				visivel: adicionalEmpresaVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: adicionalMotoristaValue?.nomeColuna,
				field: "adicionalMotorista",
				visivel: adicionalMotoristaVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: numeroEixosEmbarqueValue?.nomeColuna,
				field: "numeroEixos",
				visivel: numeroEixosEmbarqueVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: pedagioValue?.nomeColuna,
				field: "pedagio",
				visivel: pedagioVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: classificacaoValue?.nomeColuna,
				field: "classificacao",
				visivel: classificacaoVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: margemValue?.nomeColuna,
				field: "margem",
				visivel: margemVisivel?.visivel,
			},
			{
				nomeColuna: adiantamentoValue?.nomeColuna,
				field: "adiantamento",
				visivel: adiantamentoVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: saldoValue?.nomeColuna,
				field: "saldo",
				visivel: saldoVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: meioPagamentoValue?.nomeColuna,
				field: "meioPagamento",
				visivel: meioPagamentoVisivel?.visivel,
			},
			{
				nomeColuna: meioPagamento2Value?.nomeColuna,
				field: "meioPagamento2",
				visivel: meioPagamento2Visivel?.visivel,
			},
			{
				nomeColuna: kmValue?.nomeColuna,
				field: "km",
				visivel: kmVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: clienteValue?.nomeColuna,
				field: "cliente",
				visivel: clienteVisivel?.visivel,
			},
			{
				nomeColuna: embarcadorEmbValue?.nomeColuna,
				field: "embarcador",
				visivel: embarcadorEmbVisivel?.visivel,
			},
			{
				nomeColuna: destinatarioEmbValue?.nomeColuna,
				field: "destinatario",
				visivel: destinatarioEmbVisivel?.visivel,
			},
			{
				nomeColuna: loadValue?.nomeColuna,
				field: "load",
				visivel: loadVisivel?.visivel,
			},
			{
				nomeColuna: mercadoriaValue?.nomeColuna,
				field: "mercadoria",
				visivel: mercadoriaVisivel?.visivel,
			},
			{
				nomeColuna: pesoValue?.nomeColuna,
				field: "peso",
				visivel: pesoVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: embalagemEmbValue?.nomeColuna,
				field: "embalagem",
				visivel: embalagemEmbVisivel?.visivel,
			},
			{
				nomeColuna: observacaoValue?.nomeColuna,
				field: "observacao",
				visivel: observacaoVisivel?.visivel,
			},
			{
				nomeColuna: frotaValue?.nomeColuna,
				field: "frota",
				visivel: frotaVisivel?.visivel,
			},
			{
				nomeColuna: canceladoValue?.nomeColuna,
				field: "cancelado",
				visivel: canceladoVisivel?.visivel,
			},
			{
				nomeColuna: motivoEmbarqueValue?.nomeColuna,
				field: "motivo",
				visivel: motivoVisivel?.visivel,
			},
			{
				nomeColuna: usuarioResponsavelValue?.nomeColuna,
				field: "usuarioResponsavel",
				visivel: usuarioResponsavelVisivel?.visivel,
			},
			{
				nomeColuna: nEntregasValue?.nomeColuna,
				field: "nEntregas",
				visivel: nEntregasVisivel?.visivel,
			},
			{
				nomeColuna: comprovanteValue?.nomeColuna,
				field: "comprovante",
				visivel: comprovanteVisivel?.visivel,
			},
			{
				nomeColuna: checkinValue?.nomeColuna,
				field: "checkInFeito",
				visivel: checkinVisivel?.visivel,
			},
			{
				quebraColunaEmbarque: quebraTabelaEmbarque?.quebraColunaEmbarque,
			},
			{
				configDataHora: configDataHoraVisivel?.configDataHora,
			},
			{
				configEntrega: configEntregaVisivel?.configEntrega,
			},
		],
		ModeloEmbarque: [
			{
				nomeColuna: "Descrição",
				field: "descricao",
				visivel: "true",
			},
			{
				nomeColuna: unidEmbarqueValue?.nomeColuna,
				field: "unidEmbarque",
				visivel: unidEmbarqueVisivelModelo?.visivel,
			},
			{
				nomeColuna: empresaValue?.nomeColuna,
				field: "empresa",
				visivel: empresaVisivelModelo?.visivel,
			},
			{
				nomeColuna: filialValue?.nomeColuna,
				field: "filial",
				visivel: filialVisivelModelo?.visivel,
			},
			{
				nomeColuna: rotaEmbarqueValue?.nomeColuna,
				field: "rota",
				visivel: rotaEmbarqueVisivelModelo?.visivel,
			},
			{
				nomeColuna: pedidoValue?.nomeColuna,
				field: "pedido",
				visivel: pedidoVisivelModelo?.visivel,
			},
			{
				nomeColuna: cteValue?.nomeColuna,
				field: "cte",
				visivel: cteVisivelModelo?.visivel,
			},
			{
				nomeColuna: previsaoEmbarqueValue?.nomeColuna,
				field: "previsaoEmbarque",
				visivel: previsaoEmbarqueVisivelModelo?.visivel,
			},
			{
				nomeColuna: previsaoEntregaValue?.nomeColuna,
				field: "previsaoEntrega",
				visivel: previsaoEntregaVisivelModelo?.visivel,
			},
			{
				nomeColuna: dataHoraChegadaEmbarqueValue?.nomeColuna,
				field: "dataHoraChegadaEmbarque",
				visivel: dataHoraChegadaEmbarqueVisivelModelo?.visivel,
			},
			{
				nomeColuna: dataHoraEmbarcadoValue?.nomeColuna,
				field: "dataHoraEmbarcado",
				visivel: dataHoraEmbarcadoVisivelModelo?.visivel,
			},
			{
				nomeColuna: dataHoraChegadaEntregaValue?.nomeColuna,
				field: "dataHoraChegadaEntrega",
				visivel: dataHoraChegadaEntregaVisivelModelo?.visivel,
			},
			{
				nomeColuna: dataHoraEntregueValue?.nomeColuna,
				field: "dataHoraEntregue",
				visivel: dataHoraEntregueVisivelModelo?.visivel,
			},
			{
				nomeColuna: aceiteValue?.nomeColuna,
				field: "aceite",
				visivel: aceiteVisivelModelo?.visivel,
			},
			{
				nomeColuna: statusValue?.nomeColuna,
				field: "status",
				visivel: statusVisivelModelo?.visivel,
			},
			{
				nomeColuna: placaCavaloValue?.nomeColuna,
				field: "placaCavalo",
				visivel: placaCavaloVisivelModelo?.visivel,
			},
			{
				nomeColuna: placaCarretaValue?.nomeColuna,
				field: "placaCarreta",
				visivel: placaCarretaVisivelModelo?.visivel,
			},
			{
				nomeColuna: placaCarreta2Value?.nomeColuna,
				field: "placaCarreta2",
				visivel: placaCarreta2VisivelModelo?.visivel,
			},
			{
				nomeColuna: proprietarioValue?.nomeColuna,
				field: "proprietario",
				visivel: proprietarioVisivelModelo?.visivel,
			},
			{
				nomeColuna: motoristaValue?.nomeColuna,
				field: "veiculoMotorista",
				visivel: motoristaVisivelModelo?.visivel,
			},
			{
				nomeColuna: freteFiscalValue?.nomeColuna,
				field: "freteFiscal",
				visivel: freteFiscalVisivelModelo?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: icmsValue?.nomeColuna,
				field: "icms",
				visivel: icmsVisivelModelo?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: freteMotoristaValue?.nomeColuna,
				field: "freteMotorista",
				visivel: freteMotoristaVisivelModelo?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: adicionalEmpresa?.nomeColuna,
				field: "adicionalEmpresa",
				visivel: adicionalEmpresaVisivelModelo?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: adicionalMotoristaValue?.nomeColuna,
				field: "adicionalMotorista",
				visivel: adicionalMotoristaVisivelModelo?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: numeroEixosEmbarqueValue?.nomeColuna,
				field: "numeroEixos",
				visivel: numeroEixosEmbarqueVisivelModelo?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: pedagioValue?.nomeColuna,
				field: "pedagio",
				visivel: pedagioVisivelModelo?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: classificacaoValue?.nomeColuna,
				field: "classificacao",
				visivel: classificacaoVisivelModelo?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: margemValue?.nomeColuna,
				field: "margem",
				visivel: margemVisivelModelo?.visivel,
			},
			{
				nomeColuna: adiantamentoValue?.nomeColuna,
				field: "adiantamento",
				visivel: adiantamentoVisivelModelo?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: saldoValue?.nomeColuna,
				field: "saldo",
				visivel: saldoVisivelModelo?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: meioPagamentoValue?.nomeColuna,
				field: "meioPagamento",
				visivel: meioPagamentoVisivelModelo?.visivel,
			},
			{
				nomeColuna: meioPagamento2Value?.nomeColuna,
				field: "meioPagamento2",
				visivel: meioPagamento2VisivelModelo?.visivel,
			},
			{
				nomeColuna: kmValue?.nomeColuna,
				field: "km",
				visivel: kmVisivelModelo?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: clienteValue?.nomeColuna,
				field: "cliente",
				visivel: clienteVisivelModelo?.visivel,
			},
			{
				nomeColuna: embarcadorEmbValue?.nomeColuna,
				field: "embarcador",
				visivel: embarcadorEmbVisivelModelo?.visivel,
			},
			{
				nomeColuna: destinatarioEmbValue?.nomeColuna,
				field: "destinatario",
				visivel: destinatarioEmbVisivelModelo?.visivel,
			},
			{
				nomeColuna: loadValue?.nomeColuna,
				field: "load",
				visivel: loadVisivelModelo?.visivel,
			},
			{
				nomeColuna: mercadoriaValue?.nomeColuna,
				field: "mercadoria",
				visivel: mercadoriaVisivelModelo?.visivel,
			},
			{
				nomeColuna: pesoValue?.nomeColuna,
				field: "peso",
				visivel: pesoVisivelModelo?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: embalagemEmbValue?.nomeColuna,
				field: "embalagem",
				visivel: embalagemEmbVisivelModelo?.visivel,
			},
			{
				nomeColuna: observacaoValue?.nomeColuna,
				field: "observacao",
				visivel: observacaoVisivelModelo?.visivel,
			},
			{
				nomeColuna: frotaValue?.nomeColuna,
				field: "frota",
				visivel: frotaVisivelModelo?.visivel,
			},
			{
				nomeColuna: canceladoValue?.nomeColuna,
				field: "cancelado",
				visivel: canceladoVisivelModelo?.visivel,
			},
			{
				nomeColuna: motivoEmbarqueValue?.nomeColuna,
				field: "motivo",
				visivel: motivoVisivelModelo?.visivel,
			},
			{
				nomeColuna: usuarioResponsavelValue?.nomeColuna,
				field: "usuarioResponsavel",
				visivel: usuarioResponsavelVisivelModelo?.visivel,
			},
			{
				nomeColuna: nEntregasValue?.nomeColuna,
				field: "nEntregas",
				visivel: nEntregasVisivelModelo?.visivel,
			},
			{
				nomeColuna: comprovanteValue?.nomeColuna,
				field: "comprovante",
				visivel: comprovanteVisivelModelo?.visivel,
			},
			{
				nomeColuna: checkinValue?.nomeColuna,
				field: "checkInFeito",
				visivel: checkinVisivelModelo?.visivel,
			},
			{
				quebraColunaEmbarque: quebraTabelaEmbarque?.quebraColunaEmbarque,
			},
			{
				configDataHora: configDataHoraVisivelModelo?.configDataHora,
			},
		],
		Pedido: [
			{
				nomeColuna: pedidoPValue?.nomeColuna,
				field: "pedido",
				visivel: pedidoPVisivel?.visivel,
			},
			{
				nomeColuna: tipoRotaValue?.nomeColuna,
				field: "tipoRota",
				visivel: tipoRotaVisivel?.visivel,
			},
			{
				nomeColuna: freteFiscalPValue?.nomeColuna,
				field: "freteFiscal",
				visivel: freteFiscalPVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: icmsPValue?.nomeColuna,
				field: "icms",
				visivel: icmsPVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: pedagioPValue?.nomeColuna,
				field: "pedagio",
				visivel: pedagioPVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: classificacaoPValue?.nomeColuna,
				field: "classificacao",
				visivel: classificacaoPVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: kmPValue?.nomeColuna,
				field: "km",
				visivel: kmPVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: clientePValue?.nomeColuna,
				field: "cliente",
				visivel: clientePVisivel?.visivel,
			},
			{
				nomeColuna: embarcadorPValue?.nomeColuna,
				field: "embarcador",
				visivel: embarcadorPVisivel?.visivel,
			},
			{
				nomeColuna: destinatarioPValue?.nomeColuna,
				field: "destinatario",
				visivel: destinatarioPVisivel?.visivel,
			},
			{
				nomeColuna: freteMotoristaPValue?.nomeColuna,
				field: "freteMotorista",
				visivel: freteMotoristaPVisivel?.visivel,
				tipo: "number",
			},
			{
				nomeColuna: observacaoPValue?.nomeColuna,
				field: "observacao",
				visivel: observacaoPVisivel?.visivel,
			},
			{
				nomeColuna: permiteAlterarFreteFiscalValue?.nomeColuna,
				field: "permiteAlterarFreteFiscal",
				visivel: permiteAlterarFreteFiscalVisivel?.visivel,
			},
			{
				nomeColuna: valorEmbarquePedidoValue?.nomeColuna,
				field: "valorEmbarque",
				visivel: valorEmbarquePedidoVisivel?.visivel,
			},
			{
				nomeColuna: icmsEmbutidoValue?.nomeColuna,
				field: "icmsEmbutido",
				visivel: icmsEmbutidoVisivel?.visivel,
			},
			{
				nomeColuna: icmsEmbarcadorValue?.nomeColuna,
				field: "icmsEmbarcador",
				visivel: icmsEmbarcadorVisivel?.visivel,
			},
			{
				nomeColuna: freteNormalvalue?.nomeColuna,
				field: "freteNormal",
				visivel: freteNormalVisivel?.visivel,
			},
			{
				quebraColunaPedido: quebraTabelaPedido?.quebraColunaPedido,
			},
		],
	};

	const handleClick = async () => {
		setLoading(true);
		const camposFormatados = JSON.stringify(valorInicial).replace(/"/g, `'`);
		const usuarioTabela = {
			usuarioGerenId: profile?.usuario.idUsuario,
			campoVisiveis: camposFormatados,
		};
		await editaUsuarioTabelaPorId(usuarioTabela, profile?.token)
			.then(() => {
				setTabelaUsuario(valorInicial);
				setDadosRequestControllerRedux("Sucesso");
			})
			.catch((error) => {
				if (error.response.status !== 200) {
					setDadosRequestControllerRedux(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setDadosRequestControllerRedux(error.response.data);
				}
			});
		onClose();
		setLoading(false);
	};

	if (props.nome === "pedido") {
		return (
			<div>
				<Dialog open={open} onClose={handleClose}>
					<>
						{!loading ? (
							<div className="div-modal-usuario">
								<DialogTitle id="alert-dialog-title">
									{props.titulo}
								</DialogTitle>
								<DialogContent>
									<div className="div-modal-usuario">
										<FormControlLabel
											control={
												<Checkbox
													checked={
														pedidoPVisivel?.visivel === "true" ? true : false
													}
													onChange={handleOnChangePedidoPVisivel}
												/>
											}
											label={`Pedido(${pedidoPVisivel?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														tipoRotaVisivel?.visivel === "true" ? true : false
													}
													onChange={handleOnChangeTipoRotaVisivel}
												/>
											}
											label={`Tipo Rota(${tipoRotaVisivel?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														freteFiscalPVisivel?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeFreteFiscalPVisivel}
												/>
											}
											label={`Frete Fiscal(${freteFiscalPVisivel?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														icmsPVisivel?.visivel === "true" ? true : false
													}
													onChange={handleOnChangeIcmsPVisivel}
												/>
											}
											label={`ICMS(${icmsPVisivel?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														pedagioPVisivel?.visivel === "true" ? true : false
													}
													onChange={handleOnChangePedagioPVisivel}
												/>
											}
											label={`Pedágio(${pedagioPVisivel?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														classificacaoPVisivel?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeClassificacaoPVisivel}
												/>
											}
											label={`Classificação(${classificacaoPVisivel?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														kmPVisivel?.visivel === "true" ? true : false
													}
													onChange={handleOnChangeKmPVisivel}
												/>
											}
											label={`KM(${kmPVisivel?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														clientePVisivel?.visivel === "true" ? true : false
													}
													onChange={handleOnChangeClientePVisivel}
												/>
											}
											label={`Cliente(${clientePVisivel?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														embarcadorPVisivel?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeEmbarcadorPVisivel}
												/>
											}
											label={`Embarcador(${embarcadorPVisivel?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														destinatarioPVisivel?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeDestinatarioPVisivel}
												/>
											}
											label={`Destinatário(${destinatarioPVisivel?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														freteMotoristaPVisivel?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeFreteMotoristaPVisivel}
												/>
											}
											label={`Frete Motorista(${freteMotoristaPVisivel?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														observacaoPVisivel?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeObservacaoPVisivel}
												/>
											}
											label={`Observação(${observacaoPVisivel?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														permiteAlterarFreteFiscalVisivel?.visivel === "true"
															? true
															: false
													}
													onChange={
														handleOnChangePermiteAlterarFreteFiscalVisivel
													}
												/>
											}
											label={`Permite Alterar Frete Fiscal(${permiteAlterarFreteFiscalVisivel?.visivel
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														valorEmbarquePedidoVisivel?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeValorEmbarquePedidoVisivel}
												/>
											}
											label={`Valor Embarque(${valorEmbarquePedidoVisivel?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														icmsEmbutidoVisivel?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeIcmsEmbutidoVisivel}
												/>
											}
											label={`ICMS Embutido(${icmsEmbutidoVisivel?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														icmsEmbarcadorVisivel?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeIcmsEmbarcadorVisivel}
												/>
											}
											label={`ICMS Embarcador(${icmsEmbarcadorVisivel?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														freteNormalVisivel?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeFreteNormalVisivel}
												/>
											}
											label={`Frete Normal(${freteNormalVisivel?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
									</div>
								</DialogContent>
								<DialogActions>
									<div className="fixed">
										<CustomButton
											classCss="custom-button"
											titulo="OK"
											cor={coresEmpresa.botaoPadrao}
											corTexto={coresEmpresa.textoBotaoPadrao}
											onClick={handleClick}
										/>
									</div>
								</DialogActions>
							</div>
						) : (
							<LoadingComponent />
						)}
					</>
				</Dialog>
			</div>
		);
	}
	if (props.nome === "embarque") {
		return (
			<div>
				<Dialog open={open} onClose={handleClose}>
					<div className="div-modal-usuario">
						<DialogTitle id="alert-dialog-title">{props.titulo}</DialogTitle>
						<DialogContent>
							<div className="div-modal-usuario">
								<FormControlLabel
									control={
										<Checkbox
											checked={configDataHoraVisivel?.configDataHora}
											onChange={handleOnChangeConfigDataHoraVisivel}
										/>
									}
									label={`Mostrar Hora em Datas(${configDataHoraVisivel?.configDataHora ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={configEntregaVisivel?.configEntrega}
											onChange={handleOnChangeConfigEntregaVisivel}
										/>
									}
									label={`Mostrar Entregas(${configEntregaVisivel?.configEntrega ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												unidEmbarqueVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeUnidEmbarqueVisivel}
										/>
									}
									label={`Unidade de Embarque(${unidEmbarqueVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												empresaVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeEmpresaVisivel}
										/>
									}
									label={`Empresa(${empresaVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={filialVisivel?.visivel === "true" ? true : false}
											onChange={handleOnChangeFilialVisivel}
										/>
									}
									label={`Filial(${filialVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												rotaEmbarqueVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeRotaEmbarqueVisivel}
										/>
									}
									label={`Rota(${rotaEmbarqueVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={pedidoVisivel?.visivel === "true" ? true : false}
											onChange={handleOnChangePedidoVisivel}
										/>
									}
									label={`Pedido(${pedidoVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={cteVisivel?.visivel === "true" ? true : false}
											onChange={handleOnChangeCteVisivel}
										/>
									}
									label={`Cte(${cteVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												previsaoEmbarqueVisivel?.visivel === "true"
													? true
													: false
											}
											onChange={handleOnChangePrevisaoEmbarqueVisivel}
										/>
									}
									label={`Previsão Viagem(${previsaoEmbarqueVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												previsaoEntregaVisivel?.visivel === "true"
													? true
													: false
											}
											onChange={handleOnChangePrevisaoEntregaVisivel}
										/>
									}
									label={`Previsão Entrega(${previsaoEntregaVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												dataHoraChegadaEmbarqueVisivel?.visivel === "true"
													? true
													: false
											}
											onChange={handleOnChangeDataHoraChegadaEmbarqueVisivel}
										/>
									}
									label={`Data Hora Chegada Viagem(${dataHoraChegadaEmbarqueVisivel?.visivel ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												dataHoraEmbarcadoVisivel?.visivel === "true"
													? true
													: false
											}
											onChange={handleOnChangeDataHoraEmbarcadoVisivel}
										/>
									}
									label={`Data Hora Embarcado(${dataHoraEmbarcadoVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												dataHoraChegadaEntregaVisivel?.visivel === "true"
													? true
													: false
											}
											onChange={handleOnChangeDataHoraChegadaEntregaVisivel}
										/>
									}
									label={`Data Hora Chegada Entrega Viagem(${dataHoraChegadaEntregaVisivel?.visivel === "true"
										? "Sim"
										: "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												dataHoraEntregueVisivel?.visivel === "true"
													? true
													: false
											}
											onChange={handleOnChangeDataHoraEntregueVisivel}
										/>
									}
									label={`Data Hora Entregue(${dataHoraEntregueVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={aceiteVisivel?.visivel === "true" ? true : false}
											onChange={handleOnChangeAceiteVisivel}
										/>
									}
									label={`Aceite(${aceiteVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={statusVisivel?.visivel === "true" ? true : false}
											onChange={handleOnChangeStatusVisivel}
										/>
									}
									label={`Status(${statusVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												placaCavaloVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangePlacaCavaloVisivel}
										/>
									}
									label={`Placa Cavalo(${placaCavaloVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												placaCarretaVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangePlacaCarretaVisivel}
										/>
									}
									label={`Placa Carreta(${placaCarretaVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												placaCarreta2Visivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangePlacaCarreta2Visivel}
										/>
									}
									label={`Placa Segunda Carreta(${placaCarreta2Visivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												proprietarioVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeProprietarioVisivel}
										/>
									}
									label={`Proprietario(${proprietarioVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												motoristaVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeMotoristaVisivel}
										/>
									}
									label={`Motorista(${motoristaVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												freteFiscalVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeFreteFiscalVisivel}
										/>
									}
									label={`Frete Fiscal(${freteFiscalVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={icmsVisivel?.visivel === "true" ? true : false}
											onChange={handleOnChangeIcmsVisivel}
										/>
									}
									label={`ICMS(${icmsVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												freteMotoristaVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeFreteMotoristaVisivel}
										/>
									}
									label={`Frete Motorista(${freteMotoristaVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												adicionalEmpresaVisivel?.visivel === "true"
													? true
													: false
											}
											onChange={handleOnChangeAdicionalEmpresaVisivel}
										/>
									}
									label={`Adicional Empresa(${adicionalEmpresaVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												adicionalMotoristaVisivel?.visivel === "true"
													? true
													: false
											}
											onChange={handleOnChangeAdicionalMotoristaVisivel}
										/>
									}
									label={`Adicional Motorista(${adicionalMotoristaVisivel?.visivel === "true"
										? "Sim"
										: "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												numeroEixosEmbarqueVisivel?.visivel === "true"
													? true
													: false
											}
											onChange={handleOnChangeNumeroEixosEmbarqueVisivel}
										/>
									}
									label={`Eixos(${numeroEixosEmbarqueVisivel?.visivel === "true"
										? "Sim"
										: "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												pedagioVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangePedagioVisivel}
										/>
									}
									label={`Pedagio(${pedagioVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												classificacaoVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeClassificacaoVisivel}
										/>
									}
									label={`Classificação(${classificacaoVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={margemVisivel?.visivel === "true" ? true : false}
											onChange={handleOnChangeMargemVisivel}
										/>
									}
									label={`Margem(${margemVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												adiantamentoVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeAdiamentoVisivel}
										/>
									}
									label={`Adiantamento(${adiantamentoVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={saldoVisivel?.visivel === "true" ? true : false}
											onChange={handleOnChangeSaldoVisivel}
										/>
									}
									label={`Saldo(${saldoVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												meioPagamentoVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeMeioPagamentoVisivel}
										/>
									}
									label={`Meio Pagamento(${meioPagamentoVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												meioPagamento2Visivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeMeioPagamento2Visivel}
										/>
									}
									label={`Meio Pagamento Dois(${meioPagamento2Visivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={kmVisivel?.visivel === "true" ? true : false}
											onChange={handleOnChangeKmVisivel}
										/>
									}
									label={`Km(${kmVisivel?.visivel === "true" ? "Sim" : "Não"})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												clienteVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeClienteVisivel}
										/>
									}
									label={`Cliente(${clienteVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												embarcadorEmbVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeEmbarcadorEmbVisivel}
										/>
									}
									label={`Embarcador(${embarcadorEmbVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												destinatarioEmbVisivel?.visivel === "true"
													? true
													: false
											}
											onChange={handleOnChangeDestinatarioEmbVisivel}
										/>
									}
									label={`Destinatario(${destinatarioEmbVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={loadVisivel?.visivel === "true" ? true : false}
											onChange={handleOnChangeLoadVisivel}
										/>
									}
									label={`LOAD(${loadVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												mercadoriaVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeMercadoriaVisivel}
										/>
									}
									label={`Mercadoria(${mercadoriaVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={pesoVisivel?.visivel === "true" ? true : false}
											onChange={handleOnChangePesoVisivel}
										/>
									}
									label={`Peso(${pesoVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												embalagemEmbVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeEmbalagemEmbVisivel}
										/>
									}
									label={`Embalagem(${embalagemEmbVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												observacaoVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeObservacaoVisivel}
										/>
									}
									label={`Observação(${observacaoVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={frotaVisivel?.visivel === "true" ? true : false}
											onChange={handleOnChangeFrotaVisivel}
										/>
									}
									label={`Frota(${frotaVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												canceladoVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeCanceladoVisivel}
										/>
									}
									label={`Cancelado(${canceladoVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={motivoVisivel?.visivel === "true" ? true : false}
											onChange={handleOnChangeMotivoVisivel}
										/>
									}
									label={`Motivo(${motivoVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												usuarioResponsavelVisivel?.visivel === "true"
													? true
													: false
											}
											onChange={handleOnChangeUsuarioResponsavelVisivel}
										/>
									}
									label={`Usuário Responsável(${usuarioResponsavelVisivel?.visivel === "true"
										? "Sim"
										: "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												nEntregasVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeNEntregasVisivel}
										/>
									}
									label={`Entregas(${nEntregasVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												comprovanteVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeComprovanteVisivel}
										/>
									}
									label={`Comprovante(${comprovanteVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={
												checkinVisivel?.visivel === "true" ? true : false
											}
											onChange={handleOnChangeCheckinVisivel}
										/>
									}
									label={`Check-in(${checkinVisivel?.visivel === "true" ? "Sim" : "Não"
										})`}
								/>
							</div>
						</DialogContent>
						<DialogActions>
							<div className="fixed">
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									titulo="OK"
									cor="#0946B8"
									onClick={handleClick}
								/>
							</div>
						</DialogActions>
					</div>
				</Dialog>
			</div>
		);
	}
	if (props.nome === "modelo") {
		return (
			<>
				{!loading ? (
					<div>
						<Dialog open={open} onClose={handleClose}>
							<div className="div-modal-usuario">
								<DialogTitle id="alert-dialog-title">
									{props.titulo}
								</DialogTitle>
								<DialogContent>
									<div className="div-modal-usuario">
										<FormControlLabel
											control={
												<Checkbox
													checked={configDataHoraVisivelModelo?.configDataHora}
													onChange={handleOnChangeConfigDataHoraVisivelModelo}
												/>
											}
											label={`Mostrar Hora em Datas(${configDataHoraVisivelModelo?.configDataHora
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														unidEmbarqueVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeUnidEmbarqueVisivelModelo}
												/>
											}
											label={`Unidade de Embarque(${unidEmbarqueVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														empresaVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeEmpresaVisivelModelo}
												/>
											}
											label={`Empresa(${empresaVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														filialVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeFilialVisivelModelo}
												/>
											}
											label={`Filial(${filialVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														rotaEmbarqueVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeRotaEmbarqueVisivelModelo}
												/>
											}
											label={`Rota(${rotaEmbarqueVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														pedidoVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangePedidoVisivelModelo}
												/>
											}
											label={`Pedido(${pedidoVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														cteVisivelModelo?.visivel === "true" ? true : false
													}
													onChange={handleOnChangeCteVisivelModelo}
												/>
											}
											label={`Cte(${cteVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														previsaoEmbarqueVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangePrevisaoEmbarqueVisivelModelo}
												/>
											}
											label={`Previsão Viagem(${previsaoEmbarqueVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														previsaoEntregaVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangePrevisaoEntregaVisivelModelo}
												/>
											}
											label={`Previsão Entrega(${previsaoEntregaVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														dataHoraChegadaEmbarqueVisivelModelo?.visivel ===
															"true"
															? true
															: false
													}
													onChange={
														handleOnChangeDataHoraChegadaEmbarqueVisivelModelo
													}
												/>
											}
											label={`Data Hora Chegada Viagem(${dataHoraChegadaEmbarqueVisivelModelo?.visivel
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														dataHoraEmbarcadoVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={
														handleOnChangeDataHoraEmbarcadoVisivelModelo
													}
												/>
											}
											label={`Data Hora Embarcado(${dataHoraEmbarcadoVisivelModelo?.visivel ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														dataHoraChegadaEntregaVisivelModelo?.visivel ===
															"true"
															? true
															: false
													}
													onChange={
														handleOnChangeDataHoraChegadaEntregaVisivelModelo
													}
												/>
											}
											label={`Data Hora Chegada Entrega Viagem(${dataHoraChegadaEntregaVisivelModelo?.visivel
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														dataHoraEntregueVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeDataHoraEntregueVisivelModelo}
												/>
											}
											label={`Data Hora Entregue(${dataHoraEntregueVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														aceiteVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeAceiteVisivelModelo}
												/>
											}
											label={`Aceite(${aceiteVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														statusVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeStatusVisivelModelo}
												/>
											}
											label={`Status(${statusVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														placaCavaloVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangePlacaCavaloVisivelModelo}
												/>
											}
											label={`Placa Cavalo(${placaCavaloVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														placaCarretaVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangePlacaCarretaVisivelModelo}
												/>
											}
											label={`Placa Carreta(${placaCarretaVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														placaCarreta2VisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangePlacaCarreta2VisivelModelo}
												/>
											}
											label={`Placa Segunda Carreta(${placaCarreta2VisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														proprietarioVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeProprietarioVisivelModelo}
												/>
											}
											label={`Proprietario(${proprietarioVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														motoristaVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeMotoristaVisivelModelo}
												/>
											}
											label={`Motorista(${motoristaVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														freteFiscalVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeFreteFiscalVisivelModelo}
												/>
											}
											label={`Frete Fiscal(${freteFiscalVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														icmsVisivelModelo?.visivel === "true" ? true : false
													}
													onChange={handleOnChangeIcmsVisivelModelo}
												/>
											}
											label={`ICMS(${icmsVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														freteMotoristaVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeFreteMotoristaVisivelModelo}
												/>
											}
											label={`Frete Motorista(${freteMotoristaVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														adicionalEmpresaVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeAdicionalEmpresaVisivelModelo}
												/>
											}
											label={`Adicional Empresa(${adicionalEmpresaVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														adicionalMotoristaVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={
														handleOnChangeAdicionalMotoristaVisivelModelo
													}
												/>
											}
											label={`Adicional Motorista(${adicionalMotoristaVisivelModelo?.visivel ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														numeroEixosEmbarqueVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={
														handleOnChangeNumeroEixosEmbarqueVisivelModelo
													}
												/>
											}
											label={`Eixos(${numeroEixosEmbarqueVisivelModelo?.visivel
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														pedagioVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangePedagioVisivelModelo}
												/>
											}
											label={`Pedagio(${pedagioVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														classificacaoVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeClassificacaoVisivelModelo}
												/>
											}
											label={`Classificação(${classificacaoVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														margemVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeMargemVisivelModelo}
												/>
											}
											label={`Margem(${margemVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														adiantamentoVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeAdiamentoVisivelModelo}
												/>
											}
											label={`Adiantamento(${adiantamentoVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														saldoVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeSaldoVisivelModelo}
												/>
											}
											label={`Saldo(${saldoVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														meioPagamentoVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeMeioPagamentoVisivelModelo}
												/>
											}
											label={`Meio Pagamento(${meioPagamentoVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														meioPagamento2VisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeMeioPagamento2VisivelModelo}
												/>
											}
											label={`Meio Pagamento Dois(${meioPagamento2VisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														kmVisivelModelo?.visivel === "true" ? true : false
													}
													onChange={handleOnChangeKmVisivelModelo}
												/>
											}
											label={`Km(${kmVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														clienteVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeClienteVisivelModelo}
												/>
											}
											label={`Cliente(${clienteVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														embarcadorEmbVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeEmbarcadorEmbVisivelModelo}
												/>
											}
											label={`Embarcador(${embarcadorEmbVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														destinatarioEmbVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeDestinatarioEmbVisivelModelo}
												/>
											}
											label={`Destinatario(${destinatarioEmbVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														loadVisivelModelo?.visivel === "true" ? true : false
													}
													onChange={handleOnChangeLoadVisivelModelo}
												/>
											}
											label={`LOAD(${loadVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														mercadoriaVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeMercadoriaVisivelModelo}
												/>
											}
											label={`Mercadoria(${mercadoriaVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														pesoVisivelModelo?.visivel === "true" ? true : false
													}
													onChange={handleOnChangePesoVisivelModelo}
												/>
											}
											label={`Peso(${pesoVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														embalagemEmbVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeEmbalagemEmbVisivelModelo}
												/>
											}
											label={`Embalagem(${embalagemEmbVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														observacaoVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeObservacaoVisivelModelo}
												/>
											}
											label={`Observação(${observacaoVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														frotaVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeFrotaVisivelModelo}
												/>
											}
											label={`Frota(${frotaVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														canceladoVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeCanceladoVisivelModelo}
												/>
											}
											label={`Cancelado(${canceladoVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														motivoVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeMotivoVisivelModelo}
												/>
											}
											label={`Motivo(${motivoVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														usuarioResponsavelVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={
														handleOnChangeUsuarioResponsavelVisivelModelo
													}
												/>
											}
											label={`Usuário Responsável(${usuarioResponsavelVisivelModelo?.visivel ? "Sim" : "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														nEntregasVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeNEntregasVisivelModelo}
												/>
											}
											label={`Entregas(${nEntregasVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														comprovanteVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeComprovanteVisivelModelo}
												/>
											}
											label={`Comprovante(${comprovanteVisivelModelo?.visivel === "true"
												? "Sim"
												: "Não"
												})`}
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={
														checkinVisivelModelo?.visivel === "true"
															? true
															: false
													}
													onChange={handleOnChangeCheckinVisivelModelo}
												/>
											}
											label={`Check-in(${checkinVisivelModelo?.visivel === "true" ? "Sim" : "Não"
												})`}
										/>
									</div>
								</DialogContent>
								<DialogActions>
									<div className="fixed">
										<CustomButtonV2
											classCss="custom-button-cadastrar"
											classText="button-texto-cadastrar"
											titulo="OK"
											cor="#0946B8"
											onClick={handleClick}
										/>
									</div>
								</DialogActions>
							</div>
						</Dialog>
					</div>
				) : (
					<LoadingComponent />
				)}
			</>
		);
	}
}

export default ModalConfigTabela;
